import "../stylesheets/App.css";
import "../stylesheets/Intro.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Intro(props) {
  const navigate = useNavigate();

  useEffect(() => {
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "hidden";

    localStorage.setItem("category", props.category);

    const route = localStorage.getItem("user-info") ? "/" : "/login";

    const timeoutId = setTimeout(() => {
      navigate(route);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [navigate, props.category]);

  const background = {
    backgroundImage:
      "url(" +
      process.env.PUBLIC_URL +
      "/images/login/Login_Banner_Completo.webp)",
  };

  return (
    <>
      <div className="intro-container" style={background}>
        <div className="loader-container">
          <img
            className="intro-loader"
            src={process.env.PUBLIC_URL + "/images/intro/Loader.png"}
            alt="Cargando"
          />
        </div>
      </div>
    </>
  );
}

export default Intro;
